import admin from '@innovyze/stylovyze/lib/apis/auth.api';
export const getScreenSettingsByScreenNameTableName = (tableName, screenName) => {
    return admin.get(`/screen-settings/find-by-screen-name-table-name?tableName=${tableName}&screenName=${screenName}`);
};
export const createScreenSettings = (payload) => {
    return admin.post('/screen-settings', {
        tableConfigs: payload.tableConfigs,
    });
};
export const updateScreenSettings = (payload) => {
    return admin.put(`/screen-settings/${payload.screenSettingsId}`, {
        tableConfigs: payload.tableConfigs,
    });
};
